export const FRAUD_REVIEW_STATUS_QUERY_KEY = 'fraudReviewStatus';

export enum FraudReviewModalKind {
  Flag = 'flag',
  Remove = 'remove',
  Confirm = 'confirm',
}

export enum FraudReviewModalTone {
  Warning = 'warning',
  Danger = 'danger',
}

export enum FraudReviewModalConfirmColor {
  Red = 'red',
  Blue = 'blue',
}
